import { useContext } from 'react';
import type { FC, ReactElement } from 'react';

import UserContext from 'app/common/UserContext';
import {
  companyHasAccessToFeature,
  hasAccessToFeature,
  isCommonFeature
} from 'app/utils/permissions';
import type { CompanyFeature } from 'app/config/company.config';
import type { Feature } from 'app/config/features.config';

interface Props {
  children: ReactElement<any>;
  feature?: CompanyFeature | Feature;
  companyId?: number;
  condition?: boolean;
  userType?: UserType;
}

const PrivateCompanyContent: FC<Props> = ({
  children,
  feature,
  companyId: forcedCompanyId,
  userType: forcedUserType,
  condition = false
}) => {
  const { currentUser, userType: contextUserType } = useContext(UserContext);
  const companyId = forcedCompanyId ?? currentUser?.company.id;
  const userType = forcedUserType ?? contextUserType;

  if (
    condition ||
    (feature &&
      companyId &&
      !isCommonFeature(feature) &&
      companyHasAccessToFeature(feature, companyId)) ||
    (feature && userType && isCommonFeature(feature) && hasAccessToFeature(feature, userType))
  ) {
    return children;
  }

  return null;
};

PrivateCompanyContent.displayName = 'PrivateCompanyContent';

export default PrivateCompanyContent;
